<template>
  <div>
    <b-card no-header>
      <form>
        <app-personal
          label="Personal"
          labelOption="Seleccione el personal"
          :horizontal="Boolean(true)"
          :nullDisabled="Boolean(true)"
          :labelCols="labelCols"
          :nombre="personalNombre"
          :lista="personalList"
          :valido="personalValido"
          :msjInvalido="personalInvalidoMsj"
          :validate="validate"
          @updated="personalActualizado">
        </app-personal>  

        <b-form-group
          label="Observaciones"
          label-for="observaciones"
          :label-cols="labelCols"
          horizontal
          description="Observaciones de la entrega">
          <b-form-textarea
            id="observaciones"
            v-model="$v.observaciones.$model" 
            rows="5"
            max-rows="5"
            :state="observacionesValidas"
            @blur.native="validate">
          </b-form-textarea>
          <b-form-invalid-feedback id="observacionesFeedback">
            {{ observacionesInvalidasMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>
      </form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>

    <mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </mensaje>
  </div>
</template>

<script>
import Personal from '../shared/abmSelect.vue';
import { maxLength } from 'vuelidate/lib/validators';
import Mensaje from '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'

export default {
  name: 'BienesAsignacion',
  components: {
    appPersonal: Personal,
    Mensaje
  },
  mixins: [ 
    msjModal 
  ],
  data () {
    return {
      personal: null,
      observaciones: '',

      noValidar: true,
      personalValido: null,
      personalInvalidoMsj: '',
      observacionesValidas: null,
      observacionesInvalidasMsj: '',

      labelCols: 2,
      personel: [],
      personalList: [],
    }
  },
  computed: {
    personalNombre() {
      if (this.personal) {
        if (this.personal.nombre) {
          return this.personal.nombre.trim();
        }
      }
      return null;
    },
  },
  created() {
    this.getDatosAdicionales();
  },  
  methods: {
    getDatosAdicionales() {
      this.$store.dispatch('personel/getList', true)
        .then(() => {
          this.personel = this.$store.getters['personel/list'];
          this.personalList = this.$store.getters['personel/selectList'];
        })
        .catch(() => this.showErrorMsj ('Se produjo un error al recuperar el listado de personal.'))
    },    
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }
      
      if (campo == 'observaciones' || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las observaciones solo pueden contener hasta 5000 caracteres';
          }      
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      let save = true;

      let personalError = true;
      if (this.personal) {
        if (this.personal.id) {
          personalError = this.personal.id == 0;
        }
      }
      if (personalError) {
        this.personalValido = false;
        this.personalInvalidoMsj = 'Debe seleccionar el personal correspondiente'
        save = false;
      }

      if (save) {
        if (this.$v.$anyError) {
          this.displayErrores();
        } else {
          let params = {
            personalId: this.personal.id,
            observaciones: this.observaciones.trim(),
          }
          this.$emit('registrarAsignacion', params)
        }
      }
    },
    cancelar() {
      this.$emit('cancelarAsignacion')
    },
    personalActualizado(personalNombre) {
      if (personalNombre != '') {
        this.personal = this.getSelected(this.personel, personalNombre);
      } else {
        this.personal = null;
      }
      this.personalValido = null;
      this.personalInvalidoMsj = '';
    },    
  },
  validations: {
    observaciones: {
      maxLength: maxLength(5000)
    },
  },  
  watch: {
  }    
}
</script>

<style>
</style>
